<template>
  <div class="" v-if="senderDomain">
    <div class="px-8 pt-6 pb-6">
      <p class="text-xl font-bold mb-4 text-brand-black">Verify Email Sender Domain</p>
      <p class="text-sm font-medium text-brand-brown mb-2">
        Please add the following DNS records to your domain <b>{{ domain }}</b>
      </p>
      <p class="text-sm font-medium text-brand-brown mb-2">We recommend setting the TTL (Time To Live) option to <b>60</b> seconds.</p>
      <p class="text-sm font-medium text-brand-brown mb-4">After adding these records, wait a few minutes and click the "Verify" button again.</p>
      <el-table :data="senderDomainConfig" style="width: 100%">
        <!-- Sender Domain Url -->
        <el-table-column prop="type" label="Type" width="120">
          <template #default="{ row }">
            <div>
              <b>{{ row.type }}</b>
              <p v-if="row.verified" class="bg-green-200 text-green-800 font-semibold px-4 py-1 text-xs rounded-xl">Verified</p>
              <p v-else class="bg-indigo-200 text-indigo-800 font-semibold px-4 py-1 text-xs rounded-xl">Pending</p>
            </div>
          </template>
        </el-table-column>
        <!-- Sender Domain Host -->
        <el-table-column prop="host" label="Host">
          <template #default="{ row }">
            <el-tooltip class="box-item" effect="dark" content="Click to copy" placement="top">
              <pre @click="copyToClipboard(row.host, `${row.type} host`)">{{ row.host }}</pre>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- Sender Domain Value -->
        <el-table-column prop="value" label="Value">
          <template #default="{ row }">
            <el-tooltip class="box-item" effect="dark" content="Click to copy" placement="top">
              <pre @click="copyToClipboard(row.value, `${row.type} value`)">{{ row.value }}</pre>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- Cancel / Submit-->
    <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-4 rounded-b-lg">
      <el-button @click="close()" type="plain" class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg">
        <span class="text-sm text-brand-blue font-semibold">Close</span>
      </el-button>
      <!--
      <el-button type="primary" class="font-bold py-2 px-6 rounded-lg text-sm" :loading="isLoading">Add Sender Domain</el-button>
      -->
    </div>
  </div>
</template>
<script>
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { removeDomain, extractDomain } from '@/helpers/domain-utils';

export default {
  mixins: [CopyToClipboard],
  data() {
    return {
      isLoading: false,
      url: '',
    };
  },
  props: {
    senderDomain: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  async created() {
    // console.log('sender config', this.senderDomainConfig);
  },
  computed: {
    senderDomainConfig() {
      const { dkimHost, dkimValue, dkimVerified, returnPath, returnPathCname, returnPathVerified, url } = this.senderDomain;
      const rows = [
        { type: 'TXT', host: removeDomain(dkimHost, url), value: dkimValue, verified: dkimVerified },
        { type: 'CNAME', host: removeDomain(returnPath, url), value: returnPathCname, verified: returnPathVerified },
      ];
      return rows;
    },
    senderDomainUrl() {
      return this.senderDomain.url;
    },
    domain() {
      const { url } = this.senderDomain;
      return extractDomain(url);
    },
    isSenderVerified() {
      return this.senderDomain?.returnPathVerified && this.senderDomain?.dkimVerified;
    },
  },
  methods: {
    copy(value, host, message) {
      const copyValue = value.replace(`.${host}`, '');
      this.copyToClipboard(copyValue, message);
    },
  },
};
</script>
